import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, PopupContentContainer, ScreenIcon, WindowIcon, } from '@streamr/tv-ui';
import { executeSoon } from '@streamr/tv-utils';
import styled from 'styled-components';
import { MediaService } from '../../services/media/MediaService';
import { Popup, TopCenter } from '../../utils/popups';
import { StackContent } from '../Stack';
import { AbstractPopup } from './AbstractPopup';
import { PopupCssPreset } from './Popup.styles';
function ShareScreenPopup({ resolve, ...props }) {
    const mediaService = MediaService.getNotificationInterface();
    return (_jsx(ShareScreenPopupRoot, { translateFn: TopCenter, ...props, children: _jsxs(StackContent, { children: [_jsx(StyledButton, { type: "button", onClick: () => {
                        mediaService.notifyScreenShareRequested('monitor');
                        resolve();
                    }, children: _jsxs(ButtonContentContainer, { children: [_jsx(ScreenIcon, {}), _jsx("span", { children: "Entire Screen" })] }) }), _jsx(StyledButton, { type: "button", onClick: () => {
                        mediaService.notifyScreenShareRequested('window');
                        resolve();
                    }, children: _jsxs(ButtonContentContainer, { children: [_jsx(WindowIcon, {}), _jsx("span", { children: "Entire Window" })] }) }), _jsx(StyledButton, { type: "button", onClick: () => {
                        mediaService.notifyScreenShareRequested('browser');
                        resolve();
                    }, children: _jsxs(ButtonContentContainer, { children: [_jsx(WindowIcon, {}), _jsx("span", { children: "Browser tab" })] }) })] }) }));
}
const ShareScreenPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Center};
    --Popup_Padding: 1rem;
    --Popup_Width: 20rem;

    @media (min-width: 25rem) {
        ${PopupCssPreset.AnchoredTopCenter};
    }
`;
const StyledButton = styled(Button) `
    --Button_HoverTransform: 0;
    --Button_ActiveTransform: 0;
`;
const ButtonContentContainer = styled(PopupContentContainer) `
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
`;
const shareScreenPopup = Popup.create(ShareScreenPopup);
export function selectShareScreenSource(options = {}) {
    executeSoon(async () => {
        options.onOpenPopup?.();
        try {
            await shareScreenPopup.pop({
                anchorRef: options.anchorRef,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    });
}
